"use client";

import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CategoryHero() {
  const {
    ref: line1Ref,
    isVisible: line1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: line2Ref,
    isVisible: line2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: line3Ref,
    isVisible: line3Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const metadata = [{
    label: "ACERO ESTRUCTURAL"
  }, {
    label: "CERTIFICACIÓN ISO 9001"
  }, {
    label: "MÉXICO · USA · LATAM"
  }];
  return <section data-section-id="4351" id="category-hero" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-y-0 right-0 w-full md:w-2/3 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_beams_storage.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_beams_storage.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_beams_storage.webp-wvc-sizes" alt="Vigas de acero industrial en almacén de Kalisch Acero" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover scale-105 animate-[kenburns_20s_ease-in-out_infinite_alternate]" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,hsl(125_55%_10%/0.6)_100%)]" />
        {}
        <div className="absolute inset-0 opacity-[0.06] mix-blend-overlay pointer-events-none" style={{
        backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='1'/></svg>\")"
      }} />
        {}
        <div className="absolute inset-y-0 left-0 w-2/3 bg-gradient-to-r from-background via-background/90 to-transparent" />
      </div>

      {}
      <div className="absolute inset-0 md:hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-background/50 via-background/80 to-background" />
      </div>

      <style>{`
        @keyframes kenburns {
          0% { transform: scale(1); }
          100% { transform: scale(1.08); }
        }
        @keyframes scrollPulse {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 1; }
        }
      `}</style>

      {}
      <div className="relative z-10 mx-auto grid min-h-screen max-w-[1440px] grid-cols-12 gap-6 px-6 pt-28 pb-20 md:px-12 lg:px-16">
        {}
        <div className="col-span-12 md:col-span-6 lg:col-span-5 flex flex-col justify-center">
          {}
          <div ref={eyebrowRef} className={`font-mono text-[10px] md:text-xs tracking-[0.25em] uppercase text-muted-foreground mb-10 md:mb-14 transition-all duration-700 ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <span className="text-primary">01</span>
            <span className="mx-3 text-border">—</span>
            <span>KALISCH ACERO / LÍDERES EN LA INDUSTRIA</span>
          </div>

          {}
          <h1 className="font-default font-bold leading-[0.95] tracking-tighter text-foreground mb-8" style={{
          fontSize: "clamp(56px, 9vw, 144px)"
        }}>
            <div className="overflow-hidden">
              <div ref={line1Ref} className={`transition-all duration-1000 ease-out ${line1Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}>
                Fuerza
              </div>
            </div>
            <div className="overflow-hidden">
              <div ref={line2Ref} className={`transition-all duration-1000 ease-out delay-200 ${line2Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}>
                en <em className="italic text-primary font-default">Acero</em>,
              </div>
            </div>
            <div className="overflow-hidden">
              <div ref={line3Ref} className={`transition-all duration-1000 ease-out delay-500 ${line3Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}>
                Sin Límites.
              </div>
            </div>
          </h1>

          {}
          <div ref={bodyRef} className={`max-w-[380px] mb-10 transition-all duration-700 delay-700 ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground">
              Soluciones integrales en acero para los proyectos de infraestructura más ambiciosos de la región.
            </p>
          </div>

          {}
          <div ref={ctaRef} className={`flex flex-col sm:flex-row items-start sm:items-center gap-4 transition-all duration-700 delay-1000 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Button asChild size="lg" className="h-12 px-7 bg-primary text-primary-foreground hover:bg-primary-600 font-default font-semibold text-sm tracking-wider uppercase shadow-md rounded-md">
              <Link to="/CatalogPage">
                Ver Catálogo
                <ArrowUpRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild size="lg" variant="ghost" className="h-12 px-5 text-foreground hover:bg-muted hover:text-primary font-default font-semibold text-sm tracking-wider uppercase border border-border rounded-md">
              <Link to="/AboutUsPage">
                Nuestra Historia
                <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="hidden md:block md:col-span-6 lg:col-span-7" />

        {}
        <div ref={metaRef} className={`col-span-12 self-end mt-12 transition-all duration-700 delay-[1200ms] ${metaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="h-px w-full bg-border mb-6" />
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-8">
            {metadata.map((item, i) => <div key={i} data-index={i} className="font-mono text-[10px] md:text-xs tracking-[0.25em] uppercase text-muted-foreground">
                {item.label}
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="hidden lg:flex absolute right-8 top-1/2 -translate-y-1/2 z-20 flex-col items-center gap-4">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-muted-foreground" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)",
        animation: "scrollPulse 2.5s ease-in-out infinite"
      }}>
          Deslizar
        </div>
        <div className="h-24 w-px bg-gradient-to-b from-primary/60 to-transparent" />
      </div>
    </section>;
}